export class AlertsModel {
    benefitDetail: string = ''; 
    alertType: string = 'benefitCallOuts';
    alert: Boolean = false;
}